// extracted by mini-css-extract-plugin
export default {"yearsPage":"years-page_yearsPage__a16ub"};